import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = process.env.SUPABASE_URL;
export const supabaseAnonKey = process.env.SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// NOTE: password reset no longer runs through this client / the main app. It has its
// own standalone page (reset.html) backed by the PKCE `resetClient` (see
// Javascript/resetClient.js + Javascript/reset.js). That removed the five recovery
// workarounds that used to live here and in controller.js / authView.js.
